export const pagesInfoMapper = {
    'default-page' : {
        name: 'Home',
        headerClass: ' fixed top-0 ',
        containerClass: 'pt-[94px]',
        hasLeftSidebarDesktop: true,
        hasRightSidebarDesktop: true,
    },
    'event-page' : {
        name: 'Event Page',
        headerClass: 'lg:fixed lg:top-0',
        containerClass: 'pt-0',
        hasLeftSidebarDesktop: true,
        hasRightSidebarDesktop: true,
    },
    'indian-card-games' : {
        name: 'Indian Card Games',
        headerClass: ' fixed top-0 ',
        containerClass: 'pt-[94px]',
        hasLeftSidebarDesktop: false,
        hasRightSidebarDesktop: false,
    },
    'open-bets' : {
        name: 'Open Bets',
        headerClass: ' fixed top-0 ',
        containerClass: 'pt-[130px]',
        hasLeftSidebarDesktop: true,
        hasRightSidebarDesktop: true,
        headerName: 'Open Bets',
    },
    'sports-page' : {
        name: 'Sports Page',
        headerClass: ' fixed top-0 ',
        containerClass: 'pt-[130px]',
        hasLeftSidebarDesktop: true,
        hasRightSidebarDesktop: true,
        headerName: 'Sports Page',
    },
    'competition-detail-page' : {
        name: 'Sports Page',
        headerClass: ' fixed top-0 ',
        containerClass: 'pt-[130px]',
        hasLeftSidebarDesktop: true,
        hasRightSidebarDesktop: true,
        headerName: 'Competition Detail Page',
    },
    'rules-regulations' : {
        name: 'Rules & Regulations',
        headerClass: ' fixed top-0 ',
        containerClass: 'pt-[130px]',
        hasLeftSidebarDesktop: true,
        hasRightSidebarDesktop: true,
        headerName: 'Rules & Regulations',
    },
    'exclusion-policy' : {
        name: 'Exclusion policy',
        headerClass: ' fixed top-0 ',
        containerClass: 'pt-[130px]',
        hasLeftSidebarDesktop: true,
        hasRightSidebarDesktop: true,
        headerName: 'Exclusion policy',
    },
    'responsible-gambling' : {
        name: 'Responsible Gambling',
        headerClass: ' fixed top-0 ',
        containerClass: 'pt-[130px]',
        hasLeftSidebarDesktop: true,
        hasRightSidebarDesktop: true,
        headerName: 'Responsible Gambling',
    },
    'privacy-policy' : {
        name: 'Privacy Policy',
        headerClass: ' fixed top-0 ',
        containerClass: 'pt-[130px]',
        hasLeftSidebarDesktop: true,
        hasRightSidebarDesktop: true,
        headerName: 'Privacy Policy',
    },
    'change-password' : {
        name: 'Change Password',
        headerClass: ' fixed top-0 ',
        containerClass: 'pt-[130px]',
        hasLeftSidebarDesktop: true,
        hasRightSidebarDesktop: true,
        headerName: 'Change Password',
    },
    'time-setting' : {
        name: 'Time Setting',
        headerClass: ' fixed top-0 ',
        containerClass: 'pt-[130px]',
        hasLeftSidebarDesktop: true,
        hasRightSidebarDesktop: true,
        headerName: 'Time Setting',
    },
    'casino-lobby' : {
        name: 'Casino Lobby',
        headerClass: ' fixed top-0 ',
        containerClass: 'pt-[130px]',
        hasLeftSidebarDesktop: true,
        hasRightSidebarDesktop: true,
        headerName: 'Casino Lobby',
    },
    'casino-live' : {
        name: 'Casino Live',
        headerClass: ' fixed top-0 hidden lg:block',
        containerClass: 'pt-0',
        hasLeftSidebarDesktop: true,
        hasRightSidebarDesktop: true,
        headerName: 'Casino Live',
    },
    'table-casino-live' : {
        name: 'Casino Live',
        headerClass: ' fixed top-0 hidden lg:block',
        containerClass: 'pt-0',
        hasLeftSidebarDesktop: true,
        hasRightSidebarDesktop: true,
        headerName: 'Casino Live',
    },
    'aviator' : {
        name: 'Aviaotr',
        headerClass: ' fixed top-0 hidden lg:block',
        containerClass: 'pt-0',
        hasLeftSidebarDesktop: true,
        hasRightSidebarDesktop: true,
        headerName: 'Aviator',
    },
    'transactions' : {
        name: 'Transactions',
        headerClass: ' fixed top-0 ',
        containerClass: 'pt-[130px]',
        hasLeftSidebarDesktop: true,
        hasRightSidebarDesktop: true,
        headerName: 'Transactions',
    },
    'deposit' : {
        name: 'Deposit',
        headerClass: ' fixed top-0 ',
        containerClass: 'lg:pt-[130px]',
        hasLeftSidebarDesktop: true,
        hasRightSidebarDesktop: true,
        headerName: 'Deposit',
    },
    'withdraw' : {
        name: 'withdraw',
        headerClass: ' fixed top-0 ',
        containerClass: 'pt-[130px]',
        hasLeftSidebarDesktop: true,
        hasRightSidebarDesktop: true,
        headerName: 'withdraw',
    },
    'betting-profit-loss' : {
        name: 'Betting Profit & Loss',
        headerClass: ' fixed top-0 ',
        containerClass: 'pt-[130px]',
        hasLeftSidebarDesktop: true,
        hasRightSidebarDesktop: true,
        headerName: 'Betting Profit & Loss',
    },
    'betting-profit-loss-details' : {
        name: 'Betting Profit & Loss Details',
        headerClass: ' fixed top-0 ',
        containerClass: 'pt-[130px]',
        hasLeftSidebarDesktop: true,
        hasRightSidebarDesktop: true,
        headerName: 'Betting Profit & Loss Details',
    },
    'account-statement' : {
        name: 'Account Statement',
        headerClass: ' fixed top-0 ',
        containerClass: 'pt-[130px]',
        hasLeftSidebarDesktop: true,
        hasRightSidebarDesktop: true,
        headerName: 'Account Statement',
    },
    'transfer-statement' : {
        name: 'Transfer Statement',
        headerClass: ' fixed top-0 ',
        containerClass: 'pt-[130px]',
        hasLeftSidebarDesktop: true,
        hasRightSidebarDesktop: true,
        headerName: 'Transfer Statement',
    },
    'account-statement-details' : {
        name: 'Account Statement Details',
        headerClass: ' fixed top-0 ',
        containerClass: 'pt-[130px]',
        hasLeftSidebarDesktop: true,
        hasRightSidebarDesktop: true,
        headerName: 'Account Statement Details',
    },
    'livegames' : {
        name: 'Aura Casino',
        headerClass: ' fixed top-0 hidden lg:block',
        containerClass: 'pt-0',
        hasLeftSidebarDesktop: true,
        hasRightSidebarDesktop: true,
        headerName: 'Aura Casino',
    },
    'horse-racing' : {
        name: 'Horse Racing',
        headerClass: ' fixed top-0 ',
        containerClass: 'pt-[130px]',
        hasLeftSidebarDesktop: true,
        hasRightSidebarDesktop: true,
        headerName: 'Horse Racing',
    },
    'greyhound-racing' : {
        name: 'Greyhound Racing',
        headerClass: ' fixed top-0 ',
        containerClass: 'pt-[130px]',
        hasLeftSidebarDesktop: true,
        hasRightSidebarDesktop: true,
        headerName: 'Greyhound Racing',
    },
    'bonuses' : {
        name: 'Bonuses',
        headerClass: ' fixed top-0 ',
        containerClass: 'pt-[130px]',
        hasLeftSidebarDesktop: true,
        hasRightSidebarDesktop: true,
        headerName: 'Bonuses',
    },
    'bonus-statement' : {
        name: 'Bonus Statement',
        headerClass: ' fixed top-0 ',
        containerClass: 'pt-[130px]',
        hasLeftSidebarDesktop: true,
        hasRightSidebarDesktop: true,
        headerName: 'Bonus Statement',
    },
}